// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"81d92a47","824":"e5c34a6d"}[chunkId] + ".chunk.css";
};